<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  :clearable="true"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <v-layout row>
              <v-flex sm2 pt-3>Purchase Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                purchaseAmount | decFormat
              }}</v-flex>
              <v-flex sm2
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Purchase')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Purchase Discount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                purchaseDiscountAmount | decFormat
              }}</v-flex>
              <v-flex sm2
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Purchase Discount')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Purchase Return:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                purchaseReturnAmount | decFormat
              }}</v-flex>
              <v-flex sm2
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Purchase Return')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Purchase Return Discount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                purchaseReturnDiscountAmount | decFormat
              }}</v-flex>
              <v-flex sm2 mb-1
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Purchase Return Discount')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Purchase Payment:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                purchasePaymentAmount | decFormat
              }}</v-flex>
              <v-flex sm2 mb-1
                ><v-btn
                  color="primary"
                  :loading="buttonLoading"
                  @click="showDetail('Purchase Payment')"
                  >Detail</v-btn
                ></v-flex
              >
            </v-layout>
            <v-layout row>
              <v-flex sm2 pt-3>Net Amount:</v-flex>
              <v-flex sm2 pt-3 style="text-align: right">{{
                netAmount | decFormat
              }}</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Supplier list dialog -->
    <v-dialog v-model="showSupplierListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm4 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="supplierQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md2>
              <v-text-field
                name="companyName"
                label="Company Name"
                type="text"
                class="mr-1"
                v-model="supplierQueryParams.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-btn outline color="primary" @click="onSearchSupplier">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Supplier List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                v-model="selectedSupplierList"
                :headers="supplierHeaders"
                :items="supplierList"
                select-all
                class="elevation-1"
                :loading="showListLoading"
                :total-items="suppliertotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="supplierpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedSupplierList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.companyName }}</td>
                  <td>{{ props.item.address }}</td>
                  <td>{{ props.item.phone }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.contactPerson }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setSupplier">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
    <!-- Supplier list dialog -->
    <v-dialog v-model="showDetailListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-btn
            color="primary"
            :loading="buttonLoading"
            @click="detailPrintAll('printReport')"
            >Print All</v-btn
          >
          <v-btn
            color="success"
            :loading="printAllLoading"
            @click="detailExportAll()"
            >Export All</v-btn
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="detailList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{
                      props.item.issueDateInMilliSecond | format-ms-date
                    }}
                  </td>
                  <td>{{ props.item.refNo }}</td>
                  <td style="text-align: right">
                    {{ props.item.amount | decFormat }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End dialog -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Account Payable(Finance) Report [{{ detailType }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Date From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Reported Date: [{{ currentDate }}]
        </p>
      </div>
      <br />
      <div style="text-align: left">
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Purchase'"
        >
          {{ detailType }} Amount :
          {{ purchaseAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Purchase Discount'"
        >
          {{ detailType }} Amount :
          {{ purchaseDiscountAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Purchase Return'"
        >
          {{ detailType }} Amount :
          {{ purchaseReturnAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Purchase Return Discount'"
        >
          {{ detailType }} Amount :
          {{ purchaseReturnDiscountAmount | decFormat }}
        </p>
        <p
          style="font-size: 15px; margin: 1px; font-weight: bold"
          v-if="detailType == 'Purchase Payment'"
        >
          {{ detailType }} Amount :
          {{ purchasePaymentAmount | decFormat }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Ref No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in detailprintList" :key="i">
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSecond || format - ms - date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.refNo }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.amount | decFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { accountPayableService } from "../../services/account-payable-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { supplierService } from "../../services/supplier-service";
export default {
  name: "AccountPayableFinanceReport",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showDetailListDialog: false,
    printAllLoading: false,
    showSupplierListDialog: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Account Payable (Finance) Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Date", align: "left", value: "issueDate" },
      { text: "Ref No", align: "left", value: "refNo" },
      { text: "Amount", align: "left", value: "amount" },
    ],
    supplierHeaders: [
      { text: "Code", value: "code" },
      { text: "Company Name", value: "companyName" },
      { text: "Address", value: "address" },
      { text: "Phone No.", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Contact Person", value: "contact_person" },
    ],
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    queryParams: {
      fromDate: "",
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      supplierIds: [],
    },
    supplierQueryParams: {
      companyName: "",
      code: "",
    },
    selectedSupplierList: [],
    supplierList: [],
    shopList: [],
    detailList: [],
    detailprintList: [],
    suppliertotalRows: 0,
    purchaseAmount: 0,
    purchaseDiscountAmount: 0,
    purchaseReturnAmount: 0,
    purchaseReturnDiscountAmount: 0,
    purchasePaymentAmount: 0,
    netAmount: 0,
    currentDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    detailType: "",
    decimalFormat: "",
    clonequeryParams: new Object(),
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },

    supplierpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getDetailList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    onSearch() {
      this.$router.replace({
        name: "account-payable-finance-report",
        query: this.queryParams,
      });
      this.getAccountPayableFinanceSummaryReport();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getAccountPayableFinanceSummaryReport() {
      this.showListLoading = true;
      accountPayableService
        .getAccountPayableFinanceSummaryReport(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.purchaseAmount = res.data.purchaseAmount;
            this.purchaseDiscountAmount = res.data.purchaseDiscountAmount;
            this.purchaseReturnAmount = res.data.purchaseReturnAmount;
            this.purchaseReturnDiscountAmount =
              res.data.purchaseReturnDiscountAmount;
            this.purchasePaymentAmount = res.data.purchasePaymentAmount;
            this.netAmount = res.data.netAmount;
          }
        });
    },
    showSuppliers() {
      // Clean query params
      this.selectedSupplierList = [];
      this.queryParams.supplierIds = [];
      this.getSupplierList().then(
        (this.showSupplierListDialog = !this.showSupplierListDialog)
      );
    },
    getSupplierList() {
      this.showListLoading = true;
      let order = this.supplierpagination.descending ? "desc" : "asc";
      return supplierService
        .getSupplierList(
          this.supplierQueryParams,
          this.supplierpagination.page,
          this.supplierpagination.rowsPerPage,
          this.supplierpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.supplierList = res.data.supplierList;
            this.suppliertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setSupplier() {
      if (this.selectedSupplierList.length) {
        this.queryParams.supplierIds = [];
        this.selectedSupplierList.forEach((element) => {
          if (!this.queryParams.supplierIds.includes(element.id))
            this.queryParams.supplierIds.push(element.id);
        });
      }
      this.showSupplierListDialog = !this.showSupplierListDialog;
    },
    onSearchSupplier() {
      this.supplierQueryParams.page = this.supplierpagination.page;
      this.supplierQueryParams.size = this.supplierpagination.rowsPerPage;
      this.getSupplierList();
    },
    showDetail(detailType) {
      this.detailList = [];
      this.detailprintList = [];
      this.detailType = detailType;
      this.getDetailList().then(
        (this.showDetailListDialog = !this.showDetailListDialog)
      );
    },
    getDetailList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      if (this.detailType == "Purchase") {
        return accountPayableService
          .getPurchaseAmountFinanceDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netPurchaseReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Purchase Discount") {
        return accountPayableService
          .getPurchaseDiscountAmountFinanceDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netPurchaseReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Purchase Return") {
        return accountPayableService
          .getPurchaseReturnAmountFinanceDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netPurchaseReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Purchase Return Discount") {
        return accountPayableService
          .getPurchaseReturnDiscountAmountFinanceDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netPurchaseReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      } else if (this.detailType == "Purchase Payment") {
        return accountPayableService
          .getPurchasePaymentAmountFinanceDetail(
            this.clonequeryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.detailList = res.data.netPurchaseReportList;
              this.totalRows = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    detailPrintAll(divName) {
      this.printReport().finally(() => {
        var printContents = document.getElementById(divName).innerHTML;
        var reprintWindow = window.open(
          "",
          "MsgWindow",
          "width=500,height=500"
        );
        reprintWindow.document.write(printContents);
        setTimeout(() => {
          reprintWindow.print();
          reprintWindow.close();
        }, 600);
        this.buttonLoading = false;
      });
    },
    printReport() {
      this.buttonLoading = true;
      if (this.detailType == "Purchase") {
        return accountPayableService
          .getPurchaseAmountFinanceDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netPurchaseReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.detailType == "Purchase Discount") {
        return accountPayableService
          .getPurchaseDiscountAmountFinanceDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netPurchaseReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.detailType == "Purchase Return") {
        return accountPayableService
          .getPurchaseReturnAmountFinanceDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netPurchaseReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.detailType == "Purchase Return Discount") {
        return accountPayableService
          .getPurchaseReturnDiscountAmountFinanceDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netPurchaseReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (this.detailType == "Purchase Payment") {
        return accountPayableService
          .getPurchasePaymentAmountFinanceDetail(this.clonequeryParams)
          .then((res) => {
            this.detailprintList = res.data.netPurchaseReportList;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    detailExportAll() {
      this.detailprintList = [];
      this.printAllLoading = true;
      accountPayableService
        .getPurchaseAmountFinanceDetailExcelExport(
          this.clonequeryParams,
          this.detailType
        )
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },
  },
};
</script>